import { render, staticRenderFns } from "./StoreExchange.vue?vue&type=template&id=ae88ff52&scoped=true"
import script from "./StoreExchange.vue?vue&type=script&lang=ts"
export * from "./StoreExchange.vue?vue&type=script&lang=ts"
import style0 from "./StoreExchange.vue?vue&type=style&index=0&id=ae88ff52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae88ff52",
  null
  
)

export default component.exports